import { combineReducers } from 'redux';
import { Actions } from '../actions/types';
import page, { IState as PageState } from './page';
import search, { ISearchReducerState as SearchState } from './search';
import articleFeedback, {
  IState as ArticleFeedbackState,
} from './articleFeedback';

export type IState = {
  articleFeedback: ArticleFeedbackState;
  page: PageState;
  search: SearchState;
};

const reducer = combineReducers<IState, Actions>({
  articleFeedback,
  page,
  search,
});

export default reducer;
